import { render, staticRenderFns } from "./CSoonContent.vue?vue&type=template&id=47cd4e64&scoped=true"
import script from "./CSoonContent.vue?vue&type=script&lang=js"
export * from "./CSoonContent.vue?vue&type=script&lang=js"
import style0 from "./CSoonContent.vue?vue&type=style&index=0&id=47cd4e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd4e64",
  null
  
)

export default component.exports